/* src/messages/cards/MessageCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import { loadTexts } from '../../../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  Avatar,
  Button,
  Card,
  Divider,
  IconButton,
  Input,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { CloudDownload, Description, Send } from '@material-ui/icons';
import { ConfirmationPopup } from '../../../../app/components';

import { sortDates } from '../../../../util';
import styles from './styles';

import {
  fetchMessages,
  sendMessage,
  subscribeToMessages,
  acceptSupport,
  resolveSupport,
  unresolveSupport,
  fetchCustomerSupportPools,
} from '../../actions';
const TEXT_KEY = 'message';

class MessageCard extends React.Component {
  constructor(props) {
    super(props);
    this.texts = loadTexts(TEXT_KEY, props.locale);
    this.state = {
      messages: {
        messageToSend: '',
      },
      openConfirmation: false,
      confirmationType: 'accept', // 'resolve'
    };
    this._scrollToBottom = this._scrollToBottom.bind(this);
    this._onClickSend = this._onClickSend.bind(this);
    this._onChangeText = this._onChangeText.bind(this);

    this.confirmation = type => {
      const { alert } = this.texts;
      if (type === 'accept') {
        return {
          title: alert.accept_title,
          subtitle: alert.accept_subtitle,
          affirmativeButtonText: alert.accept_button,
          onSubmit: this._onClickAccept,
        };
      } else if (type === 'resolve') {
        return {
          title: alert.resolve_title,
          subtitle: alert.resolve_subtitle,
          affirmativeButtonText: alert.resolve_button,
          onSubmit: this._onClickResolve,
        };
      }

      return {};
    };
  }

  componentDidMount() {
    if (this.props.selected) {
      this._subscription = subscribeToMessages({
        supportPool: this.props.selected,
        user: this.props.selfId,
      });
      this._subscription.subscribe(() => {
        this.props.fetchMessages({
          supportPool: this.props.selected,
          page: { limit: -1 },
        });
      });
      this._scrollToBottom();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selected !== nextProps.selected) {
      if (this._subscription) {
        this._subscription.unsubscribe();
      }
      if (nextProps.selected) {
        this._subscription = subscribeToMessages({
          supportPool: nextProps.selected,
          user: this.props.selfId,
        });
        this._subscription.subscribe(async () => {
          await this.props.fetchMessages({
            supportPool: this.props.selected,
            page: { limit: -1 },
          });
          this._scrollToBottom();
        });
      }
    }
  }

  componentWillUpdate() {
    if (this.props.selected) {
      const { scrollTop, scrollHeight, clientHeight } = this._scroll;
      const scrollBottom = scrollHeight - clientHeight;
      this._scrollAtBottom = scrollBottom <= 0 || scrollTop === scrollBottom;
    }
  }

  componentDidUpdate() {
    if (this._scrollAtBottom && this.props.selected) this._scrollToBottom();
  }

  componentWillUnmount() {
    if (this._subscription) this._subscription.unsubscribe();
  }

  _onClickAccept = () => {
    this.props.acceptSupport({ supportPool: this.props.selected });
    this.setState({ openConfirmation: false });
  };

  _onClickResolve = () => {
    this.props.resolveSupport({ supportPool: this.props.selected });
    this.setState({ openConfirmation: false });
  };

  _onClickUnresolve = () => {
    this.props.unresolveSupport({ supportPool: this.props.selected });
  };

  _onOpenAcceptConfirmation = () => {
    this.setState({ openConfirmation: true, confirmationType: 'accept' });
  };
  _onOpenResolveConfirmation = () => {
    this.setState({ openConfirmation: true, confirmationType: 'resolve' });
  };
  _onCloseConfirmation = () => {
    this.setState({ openConfirmation: false });
  };

  /*
      let onClickDownload = (id, filenameOption, uriOption) =>
    switch (uriOption) {
    | None => ()
    | Some(uri) =>
      let filename =
        switch (filenameOption) {
        | None => "Untitled"
        | Some(f) => f
        };
      let a = Utils.getElementById(id);
      a->Utils.setAttribute("href", uri);
      a->Utils.setAttribute("download", filename);
      a->ReactDOMRe.domElementToObj##click();
      a->Utils.setAttribute("href", "");
    };


    * */
  _onClickDownload = (id, filename, uri) => {
    const a = document.getElementById(`a_${id}`);
    if (!a || !uri) return;
    a.setAttribute('href', uri);
    a.setAttribute('download', filename || 'Untitled');
    a.click();
    a.setAttribute('href', '');
  };

  _scrollToBottom() {
    const { scrollHeight, clientHeight } = this._scroll;
    const maxScrollTop = scrollHeight - clientHeight;
    this._scroll.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }

  async _onClickSend() {
    const supportPool = this.props.supportPools[this.props.selected];
    this.setState({ messageToSend: '' });
    await this.props.sendMessage({
      customerSupportInput: {
        _supportPool: supportPool._id,
        body: this.state.messageToSend,
        userType: 'ADMIN',
        attachment: false,
      },
    });
    await this.props.fetchMessages({
      supportPool: this.props.selected,
      page: { limit: -1 },
    });
    await this.props.fetchCustomerSupportPools();

    this.props.save(this.props.selected);
  }

  _onChangeText(event) {
    this.setState({ messageToSend: event.target.value });
  }

  renderBubble(classes, messageGroup) {
    const len = messageGroup.length;
    const { selfId } = this.props;
    return (
      <React.Fragment>
        {messageGroup.map(
          ({ _id: mid, from, createdAt, body, attachment }, i) => {
            const { _id, avatar } = from;
            const name = `${from.first} ${from.last}`;
            const first = i === 0;
            const last = i === len - 1;
            const loner = len === 1;

            const containerStyle = classNames(classes.bubbleContainer, {
              [classes.bubbleRight]: _id === selfId,
            });
            const person = _id === selfId ? 'me' : 'other';
            const bubbleStyle = classNames(classes.bubble, {
              [classes[`firstBubble-${person}`]]: first && !loner,
              [classes[`middleBubble-${person}`]]: !(first || last),
              [classes[`lastBubble-${person}`]]: last && !loner,
              [classes[`loneBubble-${person}`]]: loner,
            });

            let content = [
              <Typography className={classes.messageText}>{body}</Typography>,
            ];

            if (attachment && attachment.type) {
              if (attachment.type === 'IMAGE') {
                content.push(
                  <img
                    src={attachment.payload}
                    alt="attachment"
                    width="100%"
                  />,
                );
              } else if (attachment.type === 'VIDEO') {
                // content = (
                //   <video controls>
                //     <source src={attachment.payload} type="video/mp4" />
                //     Your browser does not support video playback
                //   </video>
                // );
                //
                content.push(
                  <video controls src={attachment.payload} width="100%" />,
                );
              } else {
                if (
                  attachment.filename &&
                  typeof attachment.filename === 'string'
                ) {
                  const split = attachment.filename.split('.');
                  // get last element
                  content.push(
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Description className={classes.messageText} />
                        <IconButton
                          onClick={() =>
                            this._onClickDownload(
                              mid,
                              attachment.filename,
                              attachment.payload,
                            )
                          }
                        >
                          <CloudDownload className={classes.messageText} />
                        </IconButton>
                      </div>
                      <Typography className={classes.messageText}>
                        {attachment.filename}
                      </Typography>
                      <a id={`a_${mid}`} target="_blank" />
                    </div>,
                  );
                } else {
                  content.push(
                    <Typography>
                      Unsupported attachment type {attachment.type}
                    </Typography>,
                  );
                }
              }
            }

            const time = (
              <Typography className={classes.time} variant="caption">
                {moment(parseInt(createdAt)).format('HH:mm')}
              </Typography>
            );

            return (
              <div key={createdAt} className={containerStyle}>
                {_id !== selfId && last && (
                  <Avatar alt={name} src={avatar} className={classes.avatar}>
                    {!avatar &&
                      name
                        .split(' ')
                        .map(n => n[0])
                        .join('')
                        .toUpperCase()}
                  </Avatar>
                )}
                {_id === selfId && time}
                <div className={bubbleStyle}>{content}</div>
                {_id !== selfId && time}
              </div>
            );
          },
        )}
      </React.Fragment>
    );
  }

  render() {
    const { classes, selected, supportPools, messages, selfId } = this.props;

    if (!selected) {
      return (
        <Card className={classes.card}>
          <div className={classes.none}>
            <Typography>{this.texts.title}</Typography>
          </div>
        </Card>
      );
    }

    const supportPool = supportPools[selected];
    const {
      user: { first, last, avatar, email, device, phone, lastLoginType },
    } = supportPool;

    let account;
    let university;

    if (lastLoginType === 'TUTOR') {
      account = supportPool.user.tutor;
      university = account
        ? account.universities.reduce((acc, u) => `${acc}, ${u.name}`, '')
        : '';
      university = university.substring(2);
    } else if (lastLoginType === 'STUDENT') {
      account = supportPool.user.student;
      university = _.get(account, 'university.name');
    }

    const organization = _.get(
      supportPool,
      `user.${lastLoginType.toLowerCase()}.organization.name`,
    );

    return (
      <Card className={classes.card}>
        <div className={classes.header}>
          <Typography variant="title">
            {first} {last} (To {supportPool.organization.name})
          </Typography>
          {supportPool.state === 'ACCEPTED' &&
            supportPool.admin._id === selfId && (
              <Button
                className={classes.resolveButton}
                onClick={this._onOpenResolveConfirmation}
                variant="contained"
                size="small"
                color="primary"
              >
                {this.texts.alert.resolve_button}
              </Button>
            )}
        </div>
        <Divider />
        <div className={classes.body} ref={node => (this._scroll = node)}>
          <div>
            <Typography>{`${this.texts.fields.login_type}: ${lastLoginType}`}</Typography>
            <Typography>{`${this.texts.fields.email}: ${email}`}</Typography>
            <Typography>{`${this.texts.fields.phone}: ${phone}`}</Typography>
            <Typography>{`${this.texts.fields.organization}: ${organization}`}</Typography>
            <Typography>{`${this.texts.fields.university}: ${university}`}</Typography>
            <Typography>{`${this.texts.fields.device}: ${device || this.texts.fields.none}`}</Typography>
          </div>
          {_.map(messages, (v, k) => (
            <React.Fragment key={k}>
              <div className={classes.dateContainer}>
                <Typography color="textSecondary">{k}</Typography>
              </div>
              {v.map((messageGroup, i) => (
                <React.Fragment key={`${k}-${i}`}>
                  {this.renderBubble(
                    classes,
                    messageGroup,
                    `${first} ${last}`,
                    avatar,
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </div>
        <Divider />
        <div className={classes.footer}>
          {supportPool.state === 'PENDING' && (
            <div className={classes.pendingFooter}>
              <Typography>{this.texts.instruction.title}</Typography>
              <Button
                onClick={this._onOpenAcceptConfirmation}
                variant="contained"
                size="large"
                color="primary"
              >
                {this.texts.instruction.button_text}
              </Button>
            </div>
          )}
          {supportPool.state === 'ACCEPTED' &&
            supportPool.admin._id === selfId && (
              <React.Fragment>
                <div className={classes.inputContainer}>
                  <Input
                    placeholder={this.texts.instruction.placeholder}
                    className={classes.input}
                    fullWidth
                    multiline
                    rowsMax={3}
                    inputProps={{ 'aria-label': 'Message' }}
                    value={this.state.messageToSend}
                    onChange={this._onChangeText}
                  />
                </div>
                <Tooltip title={this.texts.instruction.send} placement="top">
                  <IconButton onClick={this._onClickSend} color="primary">
                    <Send />
                  </IconButton>
                </Tooltip>
              </React.Fragment>
            )}
          {supportPool.state === 'ACCEPTED' &&
            supportPool.admin._id !== selfId && (
              <div className={classes.pendingFooter}>
                <Typography>{this.texts.instruction.view_only}</Typography>
              </div>
            )}
          {supportPool.state === 'RESOLVED' && (
            <div className={classes.pendingFooter}>
              <Typography>{this.texts.instruction.resolved}</Typography>
              <Button
                onClick={this._onClickUnresolve}
                variant="contained"
                size="large"
                color="primary"
              >
                {this.texts.instruction.unresolve}
              </Button>
            </div>
          )}
        </div>
        <ConfirmationPopup
          open={this.state.openConfirmation}
          onClose={this._onCloseConfirmation}
          {...this.confirmation(this.state.confirmationType)}
        />
      </Card>
    );
  }
}

MessageCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  selected: state.messages.selected.selected,
  messages: createSelector(
    state => state.messages.single.data,
    messages => {
      if (!Array.isArray(messages)) return [];
      let msg = messages.map(m => ({
        ...m,
        createdAt: parseInt(m.createdAt.timestamp, 10),
      }));
      msg.sort((a, b) => a.createdAt - b.createdAt);
      msg = _.groupBy(msg, m => moment(m.createdAt).format('MMM Do, YYYY'));
      _.forEach(msg, (v, k) => {
        let sliced = v;
        const bucket = [];
        while (!_.isEmpty(sliced)) {
          const person = sliced[0].from._id;
          const chunk = _.takeWhile(sliced, s => s.from._id === person);
          sliced = _.slice(sliced, chunk.length, sliced.length);
          bucket.push(chunk);
        }
        msg[k] = bucket;
      });

      return msg;
    },
  )(state),
  supportPools: state.messages.main.data,
  selfId: state.auth.data.user._id,
  user: createSelector(
    state => state.messages.selected.selected,
    state => state.messages.main.data,
    (selected, list) => _.get(list, `${selected}.user`),
  ),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchCustomerSupportPools: params =>
    dispatch(fetchCustomerSupportPools(params)()),
  fetchMessages: params => dispatch(fetchMessages(params)()),
  sendMessage: params => dispatch(sendMessage(params)()),
  acceptSupport: params => dispatch(acceptSupport(params)()),
  resolveSupport: params => dispatch(resolveSupport(params)()),
  unresolveSupport: params => dispatch(unresolveSupport(params)()),
});

export default compose(
  withStyles(styles, { name: 'MessageCard' }),
  connect(mapStateToProps, mapDispatchToProps),
)(MessageCard);



// WEBPACK FOOTER //
// ./src/modules/messages/cards/MessageCard/index.js